import React, { useState } from 'react';
import { CompassOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Layout, PageHeader, Table, Typography } from 'antd';
import { User } from '../../models';
import moment from 'moment';

export function ActionsPage() {
  const { Content } = Layout;
  const { Text } = Typography;

  const [loading, setLoading] = useState(false);

  const tableColumns: any[] = [
    {
      title: 'Görüşülen kişiler',
      dataIndex: 'interviewCount',
      key: 'interviewCount',
    },
    {
      title: 'Güvensiz davranış mı?',
      dataIndex: 'unsafeAction',
      key: 'unsafeAction',
      render: (unsafeAction: boolean) => (unsafeAction ? 'Evet' : 'Hayır'),
    },
    {
      title: 'Güvensiz davranış isim',
      dataIndex: 'unsafeActionUser',
      key: 'unsafeActionUser',
      render: (unsafeActionUser: User) => unsafeActionUser?.fullNameId,
    },
    {
      title: 'Olasılık',
      dataIndex: 'beforeProbability',
      key: 'beforeProbability',
    },
    {
      title: 'Şiddet',
      dataIndex: 'beforeSeverity',
      key: 'beforeSeverity',
    },
    {
      title: 'Karşı tedbir açıklaması / Fırsat',
      dataIndex: 'precautionDescription',
      key: 'precautionDescription',
    },
    {
      title: 'Oluşturma',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt: string) => moment(createdAt).format('DD.MM.yyyy HH:mm'),
    },
    {
      title: 'Alan sorumlusu',
      dataIndex: ['responsibleUser'],
      key: 'responsibleUser',
      render: (responsibleUser: User) => (responsibleUser ? responsibleUser.fullNameId : '-'),
    },
    {
      title: 'Oluşturan',
      dataIndex: 'createdBy',
      key: 'createdBy',
      render: (createdBy: User) => createdBy.fullNameId,
    },
  ];

  return (
    <>
      <PageHeader
        title={
          <>
            <CompassOutlined /> Aksiyonlar
          </>
        }
        extra={[
          <Button key="refresh" icon={<ReloadOutlined />}>
            Yenile
          </Button>,
        ]}
      />
      <Content>
        <Table columns={tableColumns} loading={loading} pagination={false} />
      </Content>
    </>
  );
}
